module.exports = __webpack_public_path__ + "img/icon-cake.02f1fb23.png";